module.exports = __webpack_public_path__ + "static/pe-ea95116f76c82964116d1575f7b8376a.svg";